<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>Guerrilla Marketing</h1>
<h1 class="bk1">Counterinsurgency and Capitalism in Colombia</h1>
<p class="bkau"><span class="sm">ALEXANDER</span> <span class="sm">L.</span> <span class="sm">FATTAL</span></p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm">&amp;</span> <span class="sm">LONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-fattal-0004.vue?245d84d3